export default __webpack_public_path__ + "static/media/logo-bollie.e1628dd4.png";